





















import {Component, Prop} from "vue-property-decorator";
import {
  DatasourceNames,
  datasourceNameToText,
  NotificationConfig,
  NotificationSensorAndConfigId,
  WhenType
} from "../../modules/notificationmodels";
import CommonBase from "@/components/CommonBase";
import NotificationConfigWhenEdit from "@/components/start/NotificationConfigWhenEdit.vue";
import NotificationConfigToEdit from "@/components/start/NotificationConfigToEdit.vue";
import NotificationConfigSensorAdd from "@/components/start/NotificationConfigSensorAdd.vue";

@Component({
  components: {
    "at-config-when-edit": NotificationConfigWhenEdit,
    "at-config-to-edit": NotificationConfigToEdit,
    "at-config-add-sensor": NotificationConfigSensorAdd,
  }
})
export default class NotificationConfigDisplaycard extends CommonBase {
  @Prop()
  config!: NotificationConfig;

  hourFormatted(h: number) {
    return String(h).padStart(2, "0");
  }

  datasourceNameTxt(ds: DatasourceNames) {
    return datasourceNameToText(ds);
  }

  get whenTxt() {
    const interval1 = this.config.whenType == WhenType.Weekly ? this.config.whenWeekDayText : this.config.whenType == WhenType.Daily ? "dag" : "???";
    return `Hver ${interval1} kl ${this.hourFormatted(this.config.whenHour || 0)}:00`;
  }

  emitDeleteSignal() {
    this.$emit("at-notif-config-remove", this.config.id);
  }

  showWhenEditDlg = false;

  get editConfig() {
    return this.config.clone(); // A copy so that edit dialogs don't appear to change things before it's saved.
  }

  showToEditDlg = false;

  emitSave(config: NotificationConfig) {
    this.$emit("at-notif-config-do-save", config);
    this.showWhenEditDlg = false;
    this.showToEditDlg = false;
  }

  showSensorAddDlg = false;

  emitAddSensor(sensorAndId: NotificationSensorAndConfigId) {
    this.$emit("at-notif-config-add-sensor", sensorAndId);
    this.showSensorAddDlg = false;
  }

  removingSensorId = 0;
  emitRemoveSensor(sensorId: number) {
    this.removingSensorId = sensorId;
    this.$emit("at-notif-config-remove-sensor", sensorId);
  }
}

